// Copyright 2019 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import { FarFieldAnalysisGuidanceCatalog } from "catalogs/GuidanceCatalog/FarFieldAnalysisGuidanceCatalog";
import { StreamingGuidanceCatalog } from "catalogs/GuidanceCatalog/StreamingGuidanceCatalog";
import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";

export class StreamerWorkflowModuleCatalog {
    static StreamerModule: IWorkflowModuleConfig = {
        name: "streamer",
        modulePath: PLATFORM.moduleName("modules/workflows/Streamer/Streamer/StreamerModule"),
        title: "Live Stream",
        moduleType: WorkflowModuleType.StreamingSettings,
        requireOnline: false,
        requireClient: true,
        requireSignIn: false,
        requireStreaming: true,
        isInadmissible: true,
        help: StreamingGuidanceCatalog.StreamingOverviewModule,
    };

    static SplModule: IWorkflowModuleConfig = {
        name: "spl_monitor",
        modulePath: PLATFORM.moduleName("modules/workflows/Streamer/SPL/SPLMonitorModule"),
        title: "Sound Level Meter",
        icon: "fas fa-thermometer-three-quarters",
        moduleType: WorkflowModuleType.Streaming,
        requireOnline: false,
        requireSignIn: false,
        requireStreaming: true,
        requireClient: true,
    };

    static SpectrumModule: IWorkflowModuleConfig = {
        name: "spectrum",
        modulePath: PLATFORM.moduleName("modules/workflows/Streamer/Spectrum/SpectrumModule"),
        title: "Spectrum",
        icon: "fas fa-chart-bar",
        moduleType: WorkflowModuleType.Streaming,
        requireOnline: false,
        requireSignIn: false,
        requireStreaming: true,
        canExtend: true,
        requireClient: true,
    };

    static WaterfallModule: IWorkflowModuleConfig = {
        name: "waterfall",
        modulePath: PLATFORM.moduleName("modules/workflows/Streamer/Waterfall/WaterfallModule"),
        title: "Spectrogram",
        icon: "fas fa-outdent",
        moduleType: WorkflowModuleType.Streaming,
        requireOnline: false,
        requireSignIn: false,
        requireStreaming: true,
        canExtend: true,
        requireClient: true,
    };

    static FarfieldModule: IWorkflowModuleConfig = {
        name: "farfield",
        modulePath: PLATFORM.moduleName("modules/workflows/Streamer/FarField/FarFieldModule"),
        title: "Far Field",
        icon: "fas fa-rss",
        help: FarFieldAnalysisGuidanceCatalog.FarFieldAnalysisOverviewStreamingModule,
        moduleType: WorkflowModuleType.Streaming,
        requireOnline: false,
        requireSignIn: false,
        requireStreaming: true,
        canExtend: true,
        requireClient: true,
    };

    static NearfieldModule: IWorkflowModuleConfig = {
        name: "nearfield",
        modulePath: PLATFORM.moduleName("modules/workflows/Streamer/NearField/NearFieldModule"),
        title: "Near Field",
        icon: "fas fa-chess-board",
        moduleType: WorkflowModuleType.Streaming,
        requireOnline: false,
        requireSignIn: false,
        requireStreaming: true,
        canExtend: true,
        requireClient: true,
    };
}
